import { render, staticRenderFns } from "./agregarProspecto.vue?vue&type=template&id=333c696b"
import script from "./agregarProspecto.vue?vue&type=script&lang=js"
export * from "./agregarProspecto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports